exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_replay_3OTq2oOrCJUgscQ0oixaiN {\n  width: 100%;\n  float: left;\n  clear: both;\n  margin-top: 20px;\n  padding: 0 40px;\n  box-sizing: border-box;\n}\n\n.IA_replay_3OTq2oOrCJUgscQ0oixaiN h3 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.IA_replay_error_message_EpKIHqvmznEjcxsP_FIrW {\n  color: red;\n  margin-top: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_replay": "IA_replay_3OTq2oOrCJUgscQ0oixaiN",
	"IA_replay_error_message": "IA_replay_error_message_EpKIHqvmznEjcxsP_FIrW"
};